import { mapState } from 'vuex';

export default {
    computed: {
        ...mapState(['basketItems']),

        outletBasketTypes() {
            const onlyUnique = (value, index, self) => self.indexOf(value) === index;
            return this.basketItems.map(basketItem => basketItem.outlet).filter(onlyUnique);
        },
    },
};
